export default {"id":"65d17d3f","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}